import React from "react";
import PropTypes from "prop-types";
import styles from "@/components/CustomComponents/MaterialContainer/index.module.scss";
import { HiChevronRight } from "react-icons/hi2";
import Image from "next/image";
import Link from "next/link";

const MaterialContainer = ({ materialData }) => {
  const { heading = "", images = {} } = materialData || {};
  return (
    <div className={styles.wrapper}>
      <div className="w-full max-[999px]:px-2">
        <div className="w-full koh-material-container mt-12 mb-5">
          <div className="koh-material-section">
            <p className="koh-material-title text-md sm:text-xl md:text-2xl font-normal text-[#232323] flex justify-items-center">
              {heading}
              <span className="flex justify-items-center">
                <HiChevronRight className="mt-1 w-5 h-5" />
              </span>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1 ">
          {images.map(({ fields, sys }) => (
            <div key={sys.id} className=" koh-meterial-category-items">
              <Link
                href={fields?.src || fields?.url}
                className="group relative block overflow-hidden  !no-underline"
              >
                <Image
                  src={fields?.imageUrl}
                  alt={fields?.alt}
                  width={0}
                  height={0}
                  className="w-full h-auto block object-cover"
                />
                <div className="p-2 transition-colors duration-300 bg-transparent group-hover:bg-[#e8e8e8] flex flex-col justify-items-center">
                  <h6 className="description">{fields?.name}</h6>
                  <p className="koh-meterial-category-items-description-explore">
                    {fields?.explore}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

MaterialContainer.propTypes = {
  materialData: PropTypes.object,
};

MaterialContainer.defaultProps = {
  materialData: {},
};
export default MaterialContainer;
